import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import {
  registrationFieldUpdate,
  postEventPasswordFieldValidate,
  registrationPostEvent,
} from "redux/ducks/Registration";
import TermsConditionsModal from "components/TermsConditionsModal";

const PostEventPassword = ({
  history,
  location,
  updateField,
  user,
  validateField,
  validation,
  registrationPostEvent,
}) => {

  const onFieldValidate = field => {
    validateField(field);
  };

  const onTermsChanged = e => {
    updateField("terms", e.target.checked);
    validateField("terms");
  };

  const onPrevious = e => {
    e.preventDefault();
    history.push("/sign-up/post-event/shift-details")
  };

  const onNext = e => {
    e.preventDefault();
    registrationPostEvent(history, location.pathname);
  };

  const onFieldChange = (field, triggerValidate) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      updateField(field, ev.currentTarget.value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  return (
    <div className="postEvent">
      <h2>To save your progress, let's quickly finish creating your account.</h2>
      <form id="accountForm" noValidate>
        <div className="form-group">
          <label className="required" htmlFor="password">Password</label>
          <input
            type="password"
            className={classnames("form-control", {
              "is-invalid": validation.errors.password
            })}
            placeholder="Password"
            value={user.password}
            name="password"
            onChange={onFieldChange("password")}
            onBlur={onFieldValidate.bind(this, "password")}
          />
          <div className="invalid-feedback">{validation.errors.password}</div>
        </div>
        <div className="form-group">
          <label className="required" htmlFor="passwordConfirmation">Confirm Password</label>
          <input
            type="password"
            className={classnames("form-control", {
              "is-invalid": validation.errors.passwordConfirmation
            })}
            value={user.passwordConfirmation}
            placeholder="Confirm Password"
            name="passwordConfirmation"
            onChange={onFieldChange("passwordConfirmation", true)}
            onBlur={onFieldValidate.bind(this, "passwordConfirmation")}
          />
          <div className="invalid-feedback">{validation.errors.passwordConfirmation}</div>
        </div>
        <label className="required checkbox">
          I have read and agree to the <a target="_blank" rel="noopener noreferrer" href="https://go4.io/privacy-policy/">Privacy Policy</a> and <a target="_blank" rel="noopener noreferrer" href="https://go4.io/terms-and-conditions/">Terms and Conditions</a>.
          <input type="checkbox" name="terms" checked={user.terms} onChange={onTermsChanged} />
          <span></span>
        </label>
        <div className="actions">
          <button
            type="button"
            className="btn btn-primary bold-button"
            onClick={onPrevious}
          >
            Previous
          </button>
          <button
            type="submit"
            className="btn btn-danger bold-button"
            disabled={!validation.valid}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.registration.user,
    validation: state.registration.postEventPasswordValidation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: field => dispatch(postEventPasswordFieldValidate(field)),
    registrationPostEvent: (history, location) => dispatch(registrationPostEvent(history, location)),
  };
}

export { PostEventPassword };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostEventPassword))
